import { Box, Button } from "@mui/material";
import React, { useState } from "react";
import styles from './QueueSystem.module.css'
import DailyAppointments from "./DailyAppointments";
import DoctorCallsQueue from "./DoctorCallsQueue";
import AskOrganizingRoom from "./AskOrganizingRoom";
import { useNavigate } from "react-router-dom";

export default function TabQueueSystem({ value }) {
    const navigate = useNavigate()

    const clickOpenQueue = () => {
        window.open('/examinationRoomQueue')
    }

    return (
        <>
            <Box sx={{
                display: 'flex',
                gap: 2,
                ml: '1rem',
                mt: 1,
                mb: 2,
                '@media (max-width: 512px)' : {
                    flexDirection: 'column',
                    mt: 3,
                }
            }}>
                <Box sx={{
                    textAlign: 'start',
                    ml:2,
                    color: '#082C91',
                    fontSize: '24px',
                    '@media (max-width: 512px)': { textAlign: 'center', }
                }}>
                    {value === 0 ? "รายชื่อนัดประจำวัน" : value === 1 ? "ซักประวัติและจัดห้อง" : "แพทย์เรียกคิว"}
                </Box>

                <Button variant="contained" onClick={()=> {clickOpenQueue()}} color="c_yellow"
                    sx={{
                        '@media (max-width: 512px)' : {
                            fontSize: '12px'
                        }
                    }}
                >
                    เปิดจอแสดงคิว
                </Button>

            </Box>

            {value === 0 && <DailyAppointments />}
            {value === 1 && <AskOrganizingRoom />}
            {value === 2 && <DoctorCallsQueue />}
        </>
    )
}